import { Route } from '@apps-common/types/routes'
import { Authentication } from '@apps-my-monitoring-root/src/pages'

export const ROUTE_AUTHENTICATE: Route = {
  key: 'authenticate',
  label: 'Authenticate',
  path: '/authenticate',
  component: Authentication,
  breadcrumbs: [{ label: 'Authenticate' }],
  icon: 'folder',
  type: 'public',
  buildPath: () => '/authenticate'
}

export const PUBLIC_ROUTES: Route[] = [ROUTE_AUTHENTICATE]
